import axios from 'axios'

const Request = async (params = {}, url, method, header = {}) => {
  const res = await new Promise((resolve, reject) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          authorization: '049a639b-63b2-437c-aaff-ea64258c767d',
          ...header
        },
        method: method || 'GET',
        url: url
      }

      if (config.method.toUpperCase() == 'GET') {
        config.params = params
      } else {
        config.data = params
      }

      axios(config).then(function (response) {
        if (response.error) {
          reject(response)
        }

        resolve(response.data)
      })
    } catch (error) {
      reject(error)
    }
  }).catch((e) => {
    return e.data
  })
  return res
}

export default Request
